// Scannable routes for multi-route scanning
export const SCANNABLE_ROUTES = [
  '/',
  '/ai-home',
  '/moderator',
  '/lovable-tools-builder',
  '/ai-community',
  '/ai-hotel',
  '/ai-hotel-academy',
  '/coda-space',
  '/coda-console',
  '/ai-liberation-dashboard',
  '/personal-ai',
  '/ai-discovery',
  '/explorer-lab',
  '/ai-testing',
  '/ai-governance',
  '/ai-meta-learning',
  '/ai-education-observatory'
];

// Default routes where MockDetector widget should be hidden (security best practice)
export const DEFAULT_HIDDEN_ROUTES = [
  '/auth',
  '/login', 
  '/signup',
  '/register',
  '/forgot-password',
  '/reset-password'
];

// Route categories for selective scanning
export const ROUTE_CATEGORIES = {
  ai: ['/ai-home', '/ai-hotel', '/ai-hotel-academy', '/ai-community', '/personal-ai'],
  moderator: ['/moderator', '/coda-console', '/lovable-tools-builder'],
  testing: ['/explorer-lab', '/ai-testing', '/qa/audit'],
  governance: ['/ai-governance', '/ai-liberation-dashboard', '/ai-education-observatory']
};
